// Copyright (c) 2016 Deere & Company

import GeneralSettings from './components/general-settings';
import actionCreators from '../shared/action-creators';
import {connect} from 'react-redux';
import {handleOnPageLeave} from '../shared/services/handle-on-page-leave';

const getStateToBindToContainerProps = state => ({
    ...state.user.preferences,
    userGeneralSettings: state.user.details.settings.general
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps,
        handleOnPageLeave
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(GeneralSettings);



// WEBPACK FOOTER //
// ./src/user/general-settings/state-connector.js